import BossModel from "@/models/BossModel";
import Product from '@/models/Product/Product'
import Package from '@/models/Package/Package'
import PublicImage from "@/models/PublicImage/PublicImage";

export default class WebsiteCustomerReview extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-customer-review';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteCustomerReviews';

    static fields() {
		return {
			id: this.number(null).nullable(),
			title: this.attr(null),
			product_id: this.number(null).nullable(),
			package_id: this.number(null).nullable(),
			review: this.attr(null),
			grade: this.number(null).nullable(),
			customer_name: this.attr(null),
			is_visible: this.boolean(true),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			public_image_id: this.number(null).nullable(),
            product: this.belongsTo(Product, 'product_id'),
            package: this.belongsTo(Package, 'package_id'),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
		}
	}

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Product() {
        return this.getRelated('product');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    Package() {
        return this.getRelated('package');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage() {
        return this.getRelated('publicImage');
    }
}
